import { Hero } from "@/components/home/Hero";
import { TopBanner } from "@/components/home/TopBanner";
import { ProgrammeChooser } from "@/components/home/ProgrammeChooser";
import { StudyBenefits } from "@/components/home/StudyBenefits";
import { VideoSection } from "@/components/home/VideoSection";
import { Marquee } from "@/components/home/Marquee";
import { Welcome } from "@/components/home/Welcome";
import { Compare } from "@/components/home/Compare";
import { Benefits } from "@/components/home/Benefits";
import { StudentExperience } from "@/components/home/StudentExperience";
import { Eligibility } from "@/components/home/Eligibility";
import { DirectEntry } from "@/components/home/DirectEntry";
import { MissedAdmission } from "@/components/home/MissedAdmission";
import { ParentSection } from "@/components/home/ParentSection";
import { AnnouncementsPreview } from "@/components/home/AnnouncementsPreview";
import { LocationSection } from "@/components/home/LocationSection";
import { FinalCTA } from "@/components/home/FinalCTA";
import { useSEO } from "@/hooks/useSite";

export default function Home() {
  useSEO({
    title: "IAUE School of Basic Studies | JUPEB & IJMB Direct Entry Programmes",
    description:
      "The School of Basic Studies, Ignatius Ajuru University of Education (IAUE), Port Harcourt — structured JUPEB & IJMB programmes preparing candidates for eligible Direct Entry into 200 Level.",
  });
  return (
    <>
      <TopBanner />
      <StudyBenefits />
      <ProgrammeChooser />
      <MissedAdmission />
      <VideoSection />
      <Hero />
      <Marquee />
      <Welcome />
      <Compare />
      <Benefits />
      <StudentExperience />
      <Eligibility />
      <DirectEntry />
      <ParentSection />
      <AnnouncementsPreview />
      <LocationSection />
      <FinalCTA />
    </>
  );
}
